import React from 'react';

function TemplatesInvoicesTab() {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Templates</h2>
      <p>Manage your invoice templates here.</p>
    </div>
  );
}

export default TemplatesInvoicesTab;
